module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdBAMAAACkvXo8AAAAIVBMVEVOTk5MTExLS0sxMTEvLy8wMDAfHx8oKCjGxsbU1NT///9JOLztAAAABnRSTlOcnZ/8/f0Wd1gfAAAAKElEQVQY02NQT0MCyQIMkauQwIoAhixk/qqEUf4A8yvR4kcEOf5SGAAoNwjwUVU62gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/checkbox-accent.png
// module id = 670
// module chunks = 0